import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { DarkTheme, LightTheme } from './theme';

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [LightTheme, DarkTheme],
});
